<script lang="ts">
	import { smartWalletCreationPending, walletConnected, walletLoaded } from '$lib/wallet/store';
	import {
		userHoldingActiveItem,
		ordersToShow,
		positionsToShow,
		orders,
		positions
	} from '$lib/home/store';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';

	export let header: string;
	let selected: boolean;
	$: selected = $userHoldingActiveItem == header.toLowerCase();
	function setPage(page: string) {
		$userHoldingActiveItem = page;
	}
</script>

{#if selected}
	<div class="flex gap-2">
		<button
			class="bg-fx-grey-800 px-5 py-2 text-center text-fx-grey-100 text-sm cursor-pointer rounded-3xl flex gap-2 items-center"
			on:click={(e) => {
				setPage(header.toLowerCase());
			}}
		>
			<div>
				{header}
			</div>

			{#if header == 'Orders'}
				<span data-testid="orders-count">
					{#if $walletLoaded && $walletConnected && !$orders.loading}
						({$ordersToShow ? $ordersToShow.length : '0'})
					{:else if ($walletLoaded && !$walletConnected) || $smartWalletCreationPending}
						(0)
					{:else}
						<ProcessingIcon />
					{/if}
				</span>
			{:else if header == 'Positions'}
				<span data-testid="positions-count">
					{#if $walletConnected && !$positions.loading}
						({$positionsToShow ? $positionsToShow.length : '0'})
					{:else if ($walletLoaded && !$walletConnected) || $smartWalletCreationPending}
						(0)
					{:else}
						<ProcessingIcon />
					{/if}
				</span>
			{/if}
		</button>
	</div>
{:else}
	<button
		class="py-2 px-5 text-center text-fx-grey-400 text-sm cursor-pointer rounded-3xl hover:bg-fx-grey-900 hover:text-fx-grey-200 flex gap-2 items-center"
		on:click={(e) => {
			setPage(header.toLowerCase());
		}}
		on:keydown={(e) => {
			setPage(header.toLowerCase());
		}}
	>
		<div>
			{header}
		</div>
		{#if ['Orders', 'Positions'].includes(header)}
			{#if header == 'Orders'}
				<span data-testid="orders-count">
					{#if $walletConnected && !$orders.loading}
						({$ordersToShow ? $ordersToShow.length : '0'})
					{:else if ($walletLoaded && !$walletConnected) || $smartWalletCreationPending}
						(0)
					{:else}
						<ProcessingIcon />
					{/if}
				</span>
			{:else if header == 'Positions'}
				<span data-testid="positions-count">
					{#if $walletConnected && !$positions.loading}
						({$positionsToShow ? $positionsToShow.length : '0'})
					{:else if ($walletLoaded && !$walletConnected) || $smartWalletCreationPending}
						(0)
					{:else}
						<ProcessingIcon />
					{/if}
				</span>
			{/if}
		{/if}
	</button>
{/if}
